export const columns = [
  {
    field: 'buyerName',
    headerName: 'Buyer Name',
    sortable: true,
    flex: 1,
  },
  {
    field: 'supplierName',
    headerName: 'Supplier Name',
    sortable: true,
    flex: 1,
  },
  {
    field: 'contactName',
    headerName: 'Contact Name',
    sortable: true,
    flex: 1.2,
  },
  {
    field: 'cardVaultStatus',
    headerName: 'Card Vaulted',
    sortable: true,
    flex: 0.9,
  },
  {
    field: 'processor',
    headerName: 'Gateway',
    sortable: true,
    flex: 0.9,
  },
  {
    field: 'createdOn',
    headerName: 'Created On',
    sortable: true,
    flex: 0.9,
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    sortable: true,
    flex: 0.9,
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: true,
    flex: 0.9,
  },
];

export const operationResultMessage = {
  ADD_REQUEST: {
    SUCCESS: 'Vaulting Request was successfully submitted.',
    ERROR: 'Vaulting Request was not submitted because: ',
  },
  DELETE_REQUEST: {
    SUCCESS: 'Vaulting Request was successfully deleted.',
    ERROR: 'Vaulting Request was not deleted because: ',
  },
  ACTIVATE_REQUEST: {
    SUCCESS: 'Vaulting Request was successfully activated.',
    ERROR: 'Vaulting Request was not activated because: ',
  },
  DEACTIVATE_REQUEST: {
    SUCCESS:
      'Vaulting Request was successfully de-activated. The link in the email is no longer active.',
    ERROR: 'Vaulting Request was not de-activated because: ',
  },
  UPDATE_REQUEST: {
    SUCCESS: 'Vaulting Request was successfully updated.',
    ERROR: 'Vaulting Request was not updated because: ',
  },
  UPDATE_ACTIVATE_REQUEST: {
    SUCCESS: 'Vaulting Request was successfully updated and activated.',
    ERROR: 'Vaulting Request was not updated and activated because: ',
  },
  UPDATE_DEACTIVATE_REQUEST: {
    SUCCESS:
      'Vaulting Request was successfully updated and de-activated. The link in the email is no longer active.',
    ERROR: 'Vaulting Request was not updated and de-activated because: ',
  },
  SEND_EMAIL: {
    SUCCESS: 'Email was successfully sent',
    ERROR: 'Failed to send email',
  },
};

export const vaultingRequestStatuses = ['ACTIVE', 'INACTIVE'];

export const pageSize = 20;
